import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import ALink from 'tradera/components/alink/alink';

const ProfileHeaderNav = ({ hasShop }) => {
    const { t } = useTranslator();

    const { memberId, aliasSlug, profilePageType } = useParams();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <div className="container">
            <div className="row d-flex flex-wrap mb-1">
                <div className="col">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <ALink
                                useLink={true}
                                className={`nav-link ${
                                    profilePageType === 'items' ? 'active' : ''
                                }`}
                                href={toLocalizedUrl(
                                    `/profile/items/${memberId}/${aliasSlug}`
                                )}>
                                {t('profileMenu_items')}
                            </ALink>
                        </li>
                        <li className="nav-item">
                            <ALink
                                useLink={true}
                                className={`nav-link ${
                                    profilePageType === 'feedback'
                                        ? 'active'
                                        : ''
                                }`}
                                href={toLocalizedUrl(
                                    `/profile/feedback/${memberId}/${aliasSlug}`
                                )}>
                                {t('profileMenu_ratings')}
                            </ALink>
                        </li>
                        {hasShop && (
                            <>
                                <li className="nav-item">
                                    <ALink
                                        useLink={true}
                                        className={`nav-link ${
                                            profilePageType === 'information'
                                                ? 'active'
                                                : ''
                                        }`}
                                        href={toLocalizedUrl(
                                            `/profile/information/${memberId}/${aliasSlug}`
                                        )}>
                                        {t('profileMenu_info')}
                                    </ALink>
                                </li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export { ProfileHeaderNav };
